module.exports = __webpack_public_path__ + "static/media/Banner1.94235e43.jpg";